<div class="appointments-page">
  <ysh-table-set [dataSource]="dataSource" (onItemTap)="didTapItem($event)"></ysh-table-set>
</div>

